import React from 'react';

interface CapitalizeFirstLetterProps {
  text: string;
  eachWord?: boolean;
}

const CapitalizeFirstLetter: React.FC<CapitalizeFirstLetterProps> = ({ text, eachWord = false }) => {
  if (!text) return null;

  const capitalizeFirst = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const capitalizeEachWord = (str: string) =>
    str.replace(/\b\w/g, char => char.toUpperCase());

  const result = eachWord ? capitalizeEachWord(text) : capitalizeFirst(text);

  return <>{result}</>;
};

export default CapitalizeFirstLetter;
